// Feefo serves a live-updating rating badge as an image — no JS needed.
const FeefoWidget = ({ merchantId }) => {
  if (!merchantId) return null

  return (
    <a
      href={`https://www.feefo.com/en-GB/reviews/${merchantId}`}
      target="_blank"
      rel="noreferrer noopener"
      style={{ display: 'inline-block', marginTop: '0.4rem' }}
    >
      <img
        src={`https://api.feefo.com/api/logo?merchantidentifier=${encodeURIComponent(merchantId)}`}
        alt="Feefo reviews"
        style={{ height: '38px', width: 'auto' }}
        loading="lazy"
      />
    </a>
  )
}

export default FeefoWidget
